"use strict";
var $dyn;
(function ($dyn) {
    var serverForm;
    (function (serverForm) {
        /**
         * Used for host window to communicated to popped out windows' InteractionHandlers.
         * Host maintains a list of Proxies for each popped out window.
         * @internal
         */
        var InteractionHandlerProxy = /** @class */ (function () {
            function InteractionHandlerProxy(_window) {
                this.window = _window;
            }
            InteractionHandlerProxy.prototype.processInteractions = function (interactions) {
                var data = {
                    commandName: $dyn.serverForm.InteractionHandlerFunction.processInteractions,
                    interactions: interactions,
                    source: "InteractionHandler",
                };
                return $dyn.postMessage(this.window, { data: data });
            };
            InteractionHandlerProxy.prototype._prepFormForPopout = function (rootId) {
                var data = {
                    commandName: $dyn.serverForm.InteractionHandlerFunction._prepFormForPopout,
                    rootId: rootId,
                    source: "InteractionHandler",
                };
                return $dyn.postMessage(this.window, { data: data });
            };
            InteractionHandlerProxy.prototype.detachFormForPopout = function (rootId) {
                var data = {
                    commandName: $dyn.serverForm.InteractionHandlerFunction.detachFormForPopout,
                    rootId: rootId,
                    source: "InteractionHandler",
                };
                return $dyn.postMessage(this.window, { data: data });
            };
            InteractionHandlerProxy.prototype.reserializeForm = function (rootId) {
                var data = {
                    commandName: $dyn.serverForm.InteractionHandlerFunction.reserializeForm,
                    rootId: rootId,
                    source: "InteractionHandler",
                };
                return $dyn.postMessage(this.window, { data: data });
            };
            return InteractionHandlerProxy;
        }());
        serverForm.InteractionHandlerProxy = InteractionHandlerProxy;
    })(serverForm = $dyn.serverForm || ($dyn.serverForm = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=InteractionHandlerProxy.js.map
